import { Link } from "react-router";

import type { Signal } from "./useAgreementSignals";

export const AgreementSignals = ({ signals }: { signals: Signal[] }) => (
  <ul className="flex flex-col gap-1">
    {signals.map((signal) => (
      <li key={signal.id} className="text-sm">
        <Link
          to={`/agreements/${signal.agreementId}/show`}
          className="underline"
        >
          {signal.text}
        </Link>
      </li>
    ))}
  </ul>
);
